<script setup lang="ts">
import MainLayout from './components/MainLayout.vue'
import TemplateRouter from './router/TemplateRouter.vue'
import {
  customElementPropsKey,
  type CustomElementProps,
} from './types/customElementProps.types'
import { onMounted, provide, ref } from 'vue'
import { useRealmSettings } from '@/stores/useRealmSettings'
import { i18n, loadLocaleMessages, setI18nLanguage } from './i18n'

const props = defineProps<CustomElementProps>()
provide(customElementPropsKey, props)

const { load: loadRealmSettings } = useRealmSettings()
const loaded = ref(false)

onMounted(async () => {
  try {
    await Promise.all([
      loadRealmSettings(props.baseUrl),
      loadLocaleMessages(i18n, props.baseUrl, props.locale),
    ])
    setI18nLanguage(i18n, props.locale)
  } finally {
    loaded.value = true
  }
})
</script>

<template>
  <MainLayout v-if="loaded">
    <template #default>
      <TemplateRouter />
    </template>
  </MainLayout>
</template>
